<div>
  <h4 style=" margin-top: 20px">Lawyer</h4>
  <div *ngIf="property.lawyer">
    <div class="buyer-item">
      <div style="width: 30%">
        <div style="display: flex">
          <div class="label">Name:</div>
          {{property.lawyer.firstName}} {{property.lawyer.lastName}}
        </div>
        <div style="display: flex">
          <div class="label">Email:</div>
          {{property.lawyer.email}}
        </div>
        <div style="display: flex">
          <div class="label">Phone:</div>
          {{property.lawyer.phoneNumber}}
        </div>
        <div style="display: flex">
          <div style="display: flex">
            <div class="label">Law firm:</div>
            {{property.lawyer.companyName ? property.lawyer.companyName : '-'}}
          </div>
        </div>
        <div style="position: absolute; right: 10px; top: calc(50% - 15px); display: flex">
          <!--          <div class="action" style="margin-right: 10px" (click)="openEditLawyerDialog(property.lawyer)" matTooltip="Edit">-->
          <!--            <img src="../../../../../../../assets/images/edit_buyer.svg">-->
          <!--          </div>-->
          <div class="action" (click)="openUnlinkLawyerDialog(property.lawyer)" matTooltip="Unlink">
            <img src="./assets/images/unlink.svg">
          </div>
        </div>
      </div>
    </div>
  </div>
  <button mat-button *ngIf="!property.lawyer" (click)="openCreateLawyerInfoDialog()"
    style="background: #161616; margin-left: 10px;border: 1px solid #DEDEDE; width: 163px;height: 52px;color: #DEDEDE;">
    Create a lawyer
  </button>
</div>